import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TruncatedBox = styled(Box)({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
});
